module.exports = __webpack_public_path__ + "0490cbaed32c486a2ecdcdd88a24cb9c.MP3";